// extracted by mini-css-extract-plugin
module.exports = {"buy":"ItemActionsBaga-buy-2d17"};